<!-- Toujours présent : la zone annonce chaque nouveau succès aux lecteurs d'écran. -->
<div role="status" aria-live="polite" aria-atomic="true" class="achievement-toast-region pointer-events-none fixed z-[9600]">
  @for (item of current(); track item.seq) {
    <button #pill type="button" class="achievement-pill rc-focus-ring pointer-events-auto"
            [attr.aria-label]="(item.achievement.secret ? 'Succès secret découvert : ' : 'Succès obtenu : ') + item.achievement.title + '. Voir dans mon profil'"
            (click)="open(item.achievement)" (animationend)="onAnimationEnd($event)">
      <span class="achievement-pill__badge" aria-hidden="true">
        <i [class]="item.achievement.icon"></i>
      </span>
      <span class="achievement-pill__clip">
        <span #text class="achievement-pill__text">
          <span class="achievement-pill__label">{{ item.achievement.secret ? 'Succès secret' : 'Succès obtenu' }}</span>
          <strong class="achievement-pill__title">{{ item.achievement.title }}</strong>
        </span>
      </span>
    </button>
  }
</div>
